import React from 'react'

function FlameSantader() {
  return (
    <svg width={36} height={32} viewBox="0 0 36 32" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25.536 14.657a6.989 6.989 0 00-1.027-3.33L18.93 2.204A7.047 7.047 0 0118.048 0l-.233.381a6.943 6.943 0 000 7.297l4.462 7.296a6.945 6.945 0 010 7.297l-.233.381a7.04 7.04 0 00-.883-2.205L14.468 9.502a7.046 7.046 0 01-.882-2.205l-.233.381a6.944 6.944 0 00-.014 7.273l4.477 7.32a6.946 6.946 0 010 7.297l-.234.381a7.04 7.04 0 00-.882-2.205l-5.578-9.121a6.97 6.97 0 01-1.028-3.965C4.122 16.131 0 19.258 0 22.88 0 27.917 7.976 32 17.815 32c9.838 0 17.814-4.083 17.814-9.12 0-3.622-4.121-6.75-10.093-8.223z"
        fill="#D8232A"
      />
    </svg>
  )
}

export default React.memo(FlameSantader)
